"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hygiea = void 0;
const Colony_1 = require("../../../colonies/Colony");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
const Resources_1 = require("../../../Resources");
class Hygiea extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.HYGIEA;
        this.description = 'Attack';
        this.buildType = ColonyBenefit_1.ColonyBenefit.OPPONENT_DISCARD;
        this.tradeType = ColonyBenefit_1.ColonyBenefit.STEAL_RESOURCES;
        this.tradeQuantity = [3, 3, 3, 3, 3, 3, 3];
        this.tradeResource = [
            Resources_1.Resources.MEGACREDITS,
            Resources_1.Resources.MEGACREDITS,
            Resources_1.Resources.HEAT,
            Resources_1.Resources.ENERGY,
            Resources_1.Resources.PLANTS,
            Resources_1.Resources.STEEL,
            Resources_1.Resources.TITANIUM,
        ];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        this.colonyBonusQuantity = 3;
        this.colonyBonusResource = Resources_1.Resources.MEGACREDITS;
        this.shouldIncreaseTrack = Colony_1.ShouldIncreaseTrack.ASK;
        this.details = [
            'Choose opponent to discard 1 card',
            'Steal 3 units of the indicated type',
            'Gain 3 M€',
        ];
    }
}
exports.Hygiea = Hygiea;
//# sourceMappingURL=Hygiea.js.map